<form (ngSubmit)="onSubmit()" #form="ngForm">
  <div
    class="flex flex-col items-center max-w-[440px] p-6 relative bg-neutrals-0"
  >
    <div class="absolute top-1 right-1 p-3" (click)="onClose()">
      <ui-icon
        name="close"
        size="20"
        mobile-size="20"
        fill="neutrals-900"
      ></ui-icon>
    </div>
    <ui-illustrative-icon
      size="m"
      mobile-size="m"
      name="i-happy-face"
    ></ui-illustrative-icon>
    <ui-paragraph
      class="mt-4 mb-3"
      type="p20"
      mobile-type="p20"
      font-weight="semibold"
      text-color="primary-700"
      content="¿Qué más te gustaría ver aquí?"
    />
    <ui-paragraph
      class="mb-6 text-center"
      type="p14"
      mobile-type="p14"
      font-weight="regular"
      text-color="neutrals-700"
      content="Ayúdanos a entender qué datos te serían más útiles para tomar mejores decisiones."
    />
    <textarea
      [(ngModel)]="message"
      name="message"
      required
      minlength="2"
      maxlength="300"
      #messageField="ngModel"
      rows="4"
      placeholder="Escribe tus comentarios aquí..."
      class="w-full p-3 border rounded-xl focus:outline-none border-neutrals-400 text-sm bg-neutrals-0 text-neutrals-600"
      [class.border-red-500]="
        messageField.invalid && (messageField.dirty || isLoading)
      "
    ></textarea>

    <div
      *ngIf="messageField.invalid && (messageField.dirty || isLoading)"
      class="text-red-500 text-sm mt-1"
    >
      <div *ngIf="messageField.errors?.['required']">
        Este campo es obligatorio.
      </div>
      <div *ngIf="messageField.errors?.['minlength']">
        Debe tener al menos 2 caracteres.
      </div>
    </div>

    <ui-button
      class="mt-6 w-full"
      type="primary"
      responsive="false"
      size="lg"
      button-text="Enviar comentarios"
      [enabled]="form.valid"
      [isLoading]="isLoading"
      (clicked)="onSubmit()"
    ></ui-button>
  </div>
</form>
